/*! class: lightbox, lns-image-gallery */
(function() {
  'use strict';
  // polyfill closest
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

  function lightbox (event) {
    var focus_backup = event.target;
    let language = document.documentElement.lang || 'en';
    let titleTxt, nextTxt, prevTxt;
    switch (language.slice(0, 2)) {
      case 'de':
        titleTxt = 'Lightbox';
        nextTxt = 'Nächster (Pfeil rechts)';
        prevTxt = 'Vorheriger (Pfeil links)';
        break;
      default:
        titleTxt = 'Lightbox';
        nextTxt = 'Next (Arrow right)';
        prevTxt = 'Previous (Arrow left)';
        break;
    }
    let gallery = this.closest("[data-type='gallery']");
    if (!gallery) {
      gallery = this.closest("[data-type='slider']");
    }
    var items = [], index, figure = null, itemof, closeBtn, prevBtn, nextBtn;
    var inertSiblings = [];
    event.preventDefault();
    var overlay = document.createElement('div');
    overlay.id = 'overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'popup-title');
    document.body.appendChild(overlay);
    document.body.classList.add('dialog-is-open');

    // Make all siblings outside the lightbox inert while the dialog is open
    let bodyChildren = document.body.children;
    for (let i = 0; i < bodyChildren.length; i++) {
      let child = bodyChildren[i];
      if (child !== overlay) {
        if (!child.hasAttribute('inert')) {
          inertSiblings.push(child);
        }
        child.inert = true;
      }
    }
    var content = document.createElement('div');
    content.id = 'popup-content';
    overlay.appendChild(content);

    var inner = document.createElement('div');
    inner.className = 'inner';
    content.appendChild(inner);

    let heading = document.createElement('h2');
    heading.id = 'popup-title';
    heading.className = 'sr-only';
    heading.appendChild(document.createTextNode(titleTxt));
    inner.appendChild(heading);

    // close button
    closeBtn = document.createElement('button');
    closeBtn.setAttribute('type', 'button');
    closeBtn.className = 'popup-close';
    let closeIcon = document.createElement('span');
    closeIcon.className = 'popup-close-icon';
    closeIcon.appendChild(document.createTextNode('Schließen [X]'));
    closeBtn.appendChild(closeIcon);
    inner.appendChild(closeBtn);
    closeBtn.focus();

    function close(event) {
      console.log('lightbox.js close');
      event.stopPropagation();
      event.preventDefault();
      // remove all eventListener
      document.removeEventListener('keydown', keyPress);
      overlay.removeEventListener('click', close);
      closeBtn.removeEventListener('click', close);
      closeBtn.removeEventListener('keydown', keyPress);
      if (prevBtn) {
        prevBtn.removeEventListener('click', previous);
        prevBtn.removeEventListener('keydown', keyPress);
      }
      if (nextBtn) {
        nextBtn.removeEventListener('click', next);
        nextBtn.removeEventListener('keydown', keyPress);
      }
      // Restore inert state
      for (let i = 0; i < inertSiblings.length; i++) {
        inertSiblings[i].inert = false;
      }
      // remove lightbox & overlay
      document.body.removeChild(overlay);
      document.body.classList.remove('dialog-is-open');
      // set the focus back to last focused element before lightbox was opened (usually the lightbox trigger button)
      focus_backup.focus();
    }

    function previous (event) {
      event.stopPropagation();
      showItem((index == 0) ? items[items.length-1] : items[index-1]);
    }
    function next (event) {
      event.stopPropagation();
      showItem((index == items.length-1) ? items[0] : items[index+1]);
    }
    function keyPress (event) {
      switch (event.key) {
        case 'Escape':
          close(event);
          break;
        case 'ArrowLeft':
          if (prevBtn) {
            previous(event);
          }
          break;
        case 'ArrowRight':
          if (nextBtn) {
            next(event);
          }
          break;
        case 'Enter':
          // prevent double action on Enter keypress for buttons (click + keydown)
          event.preventDefault()
          if (event.target.classList.contains('popup-close')) {
            close(event);
          } else if (event.target.classList.contains('prev')) {
            previous(event);
          } else if (event.target.classList.contains('next')) {
            next(event);
          }
          break;
      }
    }
    // add eventListener Escape, ArrowLeft, ArrowRight
    document.addEventListener('keydown', keyPress);
    // add eventListener close button click and keypress Enter
    closeBtn.addEventListener('click', close);
    closeBtn.addEventListener('keydown', keyPress);
    // show item
    function showItem (el) {
      for (let i=0; i<items.length; i++) {
        if (items[i] == el) {
          index = i;
          break;
        }
      }
      // remove figure of last element
      if (figure) {
        inner.removeChild(figure);
        figure = null;
      }
      if (el.classList.contains('image')) {
        let a = el.querySelector('a');
        if (a) {
          // create image & copy figure caption
          figure = document.createElement('figure');
            inner.appendChild(figure);
          let img = document.createElement('img');
          img.src = a.getAttribute('href');
          let div = document.createElement('div');
          div.classList.add('image-height');
          div.appendChild(img);
          figure.appendChild(div);
          let orgfigcaption = el.querySelector("figcaption");
          if (orgfigcaption) {
            let figcaption = orgfigcaption.cloneNode(true);
            figure.appendChild(figcaption);
          }
        }
      }
      if (!figure) {
        // copy other figure content like videos
        figure = el.cloneNode(true);
        inner.appendChild(figure);
        let media = figure.querySelector('video');
        if (media) {
          media.setAttribute('controls', 'controls');
        }
        media = figure.querySelector('audio');
        if (media) {
          media.setAttribute('controls', 'controls');
        }
      }
      // remove old position
      if (itemof) {
        inner.removeChild(itemof);
      }
      // set new position
      if (items.length > 1) {
        itemof = document.createElement('span');
        itemof.classList.add('itemof');
        itemof.appendChild(document.createTextNode(index+1 + ' von ' + items.length));
        inner.appendChild(itemof);
      }
    }
    if (gallery) {
      let galleryitems = gallery.querySelectorAll('figure');
      for (let i=0; i<galleryitems.length; i++) {
        // exclude (slide) clone elements
        if (!galleryitems[i].classList.contains('clone')) {
          items.push(galleryitems[i]);
        }
      }
      if (items.length > 1) {
        prevBtn = document.createElement('button');
        prevBtn.setAttribute('type', 'button');
        prevBtn.className = 'prev';
        prevBtn.setAttribute('title', prevTxt);
        prevBtn.setAttribute('aria-hidden', 'true');
        let span = document.createElement('span');
        span.className = 'sr-only';
        span.appendChild(document.createTextNode(prevTxt));
        prevBtn.appendChild(span);
        // add eventListener previous button click and keypress Enter
        prevBtn.addEventListener('click', previous);
        prevBtn.addEventListener('keydown', keyPress);
        overlay.appendChild(prevBtn);
        nextBtn = document.createElement('button');
        nextBtn.setAttribute('type', 'button');
        nextBtn.className = 'next';
        nextBtn.setAttribute('title', nextTxt);
        nextBtn.setAttribute('aria-hidden', 'true');
        span = document.createElement('span');
        span.className = 'sr-only';
        span.appendChild(document.createTextNode(nextTxt));
        nextBtn.appendChild(span);
        // add eventListener next button click and keypress Enter
        nextBtn.addEventListener('click', next);
        nextBtn.addEventListener('keydown', keyPress);
        overlay.appendChild(nextBtn);
      }
    }
    let el = this.closest("figure");
    showItem(el);
  }

  // add event listener to all lightbox elements
  let figure = document.querySelectorAll("figure a[data-type='lightbox']");
  if (figure.length > 0) {
    for (let i = 0; i < figure.length; i++) {
      figure[i].addEventListener('click', lightbox);
    }
  }
})();
